module.exports = __webpack_public_path__ + "img/product_pressalit_wash03.81eed06c.jpg";